<div class="jb-grid">
  <jb-list [listData]="list"></jb-list>
</div>
